import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
//
import { Button, Dropdown } from "react-bootstrap";

//
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(originalMoment);

function DateSelect({
  title,
  icon,
  activeFilter,
  action,
  fit = false,
  full = false,
  align = "start",
}) {
  const onSelect = (val) => {
    action(val);
  };

  const setTime = () => {
    action(moment());
  };

  // useEffect(() => {
  //   setTime()

  //   // eslint-disable-next-line
  // }, [])

  const renderSelectionValue = () => {
    return <>{activeFilter.format("YYYY-MM-DD")}</>;
  };

  return (
    <Dropdown align={align} id="custom-date">
      <Dropdown.Toggle className={full ? "full" : ""}>
        {icon && <i className={icon}></i>}

        {title && <span className="title">{title} :</span>}
        {activeFilter ? (
          <span>{renderSelectionValue()}</span>
        ) : (
          <span className="text-muted">Select one</span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className={fit ? "fit" : ""}>
        <div className="d-flex flex-column">
          <DateRangePicker
            value={activeFilter}
            onSelect={onSelect}
            selectionType="single"
          />
          <Dropdown.Item className="close-btn">
            <Button variant="info">Close</Button>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

DateSelect.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  activeFilter: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  fit: PropTypes.bool,
  full: PropTypes.bool,
  align: PropTypes.string,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(DateSelect);
